import React from 'react';
import Resource from '../../../common/Resource'
import Panel from '../../../common/layout/Panel'


export default class extends React.Component {
    render () {
        var accountId = this.props.match.params.account_id;
        const data = {
            url: `/admin/clients/accounts/${accountId}/mmsaccounts`,
            data: {
                data: [],
                metadata: []
            },
            metadata: [
                {
                    label: 'id',
                    source: 'mms_account_id',
                    type: 'primary',
                    editable: false,
                    visible: false
                },
                {
                    label: 'MM4 Username',
                    source: 'username',
                    type: 'text',
                    editable: true,
                    default: '',
                    placeholder: 'mmsusername'
                },
                {
                    label: 'Password',
                    source: 'password',
                    type: 'password',
                    editable: true,
                    default: '',
                    placeholder: ''
                },
                {
                    label: 'Product',
                    source: 'product_id',
                    type: 'select',
                    editable: true,
                    default: '1'
                },
                {
                    label: 'Enabled',
                    source: 'status',
                    type: 'checkbox',
                    editable: true,
                    default: true
                },
                {
                    label : 'Actions',
                    type: 'action_buttons'
                }
            ]
        }
        return (
            <Panel title = "MMS/MM4 Accounts">
                <Resource
                    addButtonText = "Add MMS/MM4 Account"
                    data = {data}
                    {...this.props}
                />
            </Panel>
        )
    }
}
